import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { FileTransfer } from '@ionic-native/file-transfer';
import { Storage } from '@ionic/storage';
import { Platform } from 'ionic-angular';
import { Employee } from '../../model/chat/employee';
import { Message } from '../../model/chat/message';
import { Paginate } from '../../model/chat/paginate';
import { Partner } from '../../model/chat/partner';
import { Rooms } from '../../model/chat/rooms';
import { GDAuthInterface } from '../../model/gd-auth';
import { RequestGetEmpDto } from '../../shared/nestjs/gd-only/dto/employees.dto';
import { EmployeesApi } from '../../shared/nestjs/gd-only/services/employees.api';
import { NestAuthProvider } from '../../shared/nestjs/nest-auth';
import { NestResponsesProvider, ResponseData } from '../../shared/nestjs/nest-responses';
import { FileDownloaderProvider } from '../file-downloader/file-downloader';
import { LoadingServiceProvider } from '../loading-service/loading-service';
import { PermissionCheckProvider } from '../permission-check/permission-check';
import { SFGOAuthService } from '../sfgoauth.service/sfgoauth.service';
import { StoragePathProvider } from '../storage-path/storage-path';
import { ToastServiceProvider } from '../toast-service/toast.service';

@Injectable()
export class ChatServiceProvider {
  goPath: string = "https://socket.dataon.com/";
  // goPath: string = "https://361c3a85.ngrok.io/";
  // goPath: string = "http://172.16.8.144:3000/";

  accessToken: any;
  headerOptions: any;
  headerOptionsJson: any;
  SFGoAuth: GDAuthInterface;
  private unreadChat: number = 0;

  constructor(public http: HttpClient,
    public storage: Storage,
    public sfGoAuthService: SFGOAuthService,
    public platform: Platform,
    public transfer: FileTransfer,
    public permissionCheck: PermissionCheckProvider,
    public loadingService: LoadingServiceProvider,
    public toastService: ToastServiceProvider,
    public file: File,
    public fileOpener: FileOpener,
    public sfgoAuthService: SFGOAuthService,
    public nestAuth: NestAuthProvider,
    public fileDownloaderProvider: FileDownloaderProvider,
    public storagePathProvider: StoragePathProvider,
    public nestResponseProvider: NestResponsesProvider,
    public employeeApi: EmployeesApi
  ) {
    this.getGoPath();
    this.getAuthUpdate();
  }

  // GET FROM STORAGE
  getGoPath(): Promise<void> {
    return new Promise(async (resolve) => {
      await this.setAuthorization();
      resolve();
    });
  }

  getAuthUpdate() {
    this.nestAuth.setAuth.subscribe(async (data) => {
      await this.getGoPath();
    })
  }

  public set setUnreadCount(count: any) {
    this.unreadChat = count;
  }

  public get getUnreadCount() {
    return this.unreadChat;
  }

  setAuthorization(): Promise<void> {
    return new Promise(async (resolve) => {
      this.SFGoAuth = await this.sfgoAuthService.getAuthorization();
      if (this.SFGoAuth && this.SFGoAuth.socket != null) {
        if (this.SFGoAuth.socket.api != "" && this.SFGoAuth.socket.api != null && this.SFGoAuth.socket.api != undefined) {
          this.goPath = `${this.SFGoAuth.socket.api}/`
        }
        this.accessToken = this.SFGoAuth.id;
        this.headerOptions = new HttpHeaders().set('Authorization', this.accessToken);
        this.headerOptionsJson = new HttpHeaders().set('Authorization', this.accessToken).append('Content-Type', 'application/json');
      }
      resolve();
    });
  }

  // ALL METHOD GET
  getAllRooms(page: number = 1, limit: number = 20) {
    return this.http.get<Paginate<Rooms[]>>(this.goPath + `rooms?page=${page}&limit=${limit}`, { headers: this.headerOptions });
  }

  getEmployee(page: number = 1, limit: number = 20) {
    const payload: RequestGetEmpDto = {
      dataAuth: false,
      fullName: '',
      paging: true,
      notEmpIds: [this.SFGoAuth.empId],
      positionId: [],
      active: '1',
      gender: null,
      userId: null
    }

    return this.employeeApi.getEmp(payload, { page: page, limit: limit });
  }

  getAllMessage(roomId: any, page: number = 1, limit: number = 20) {
    return this.http.get<Paginate<Message[]>>(this.goPath + `messages?roomId=${roomId}&page=${page}&limit=${limit}`, { headers: this.headerOptions });
  }

  getAllMember(roomId: string, page: number = 1, limit: number = 10) {
    return this.http.get<Paginate<Partner[]>>(this.goPath + `members/room-members?roomId=${roomId}&page=${page}&limit=${limit}`, { headers: this.headerOptions });
  }

  searchRooms(criteria: any) {
    return this.http.get<Paginate<Rooms[]>>(this.goPath + `rooms/search?keyword=${criteria.keyword}&follow=true`, { headers: this.headerOptions });
  }

  searchEmployee(criteria: any, page: number = 1, limit: number = 30) {
    return this.http.get<Paginate<Employee[]>>(this.goPath + `employees/search?q=${criteria.keyword}&page=${page}&limit=${limit}`, { headers: this.headerOptions });
  }

  searchGetNewMember(roomId: string, keyword: string = "", page: number = 1, limit: number = 30) {
    return this.http.get<Paginate<Employee[]>>(this.goPath + `members/searchNewMember?roomId=${roomId}&page=${page}&limit=${limit}&q=${keyword}`, { headers: this.headerOptions });
  }

  getFileByGroup(roomId: string, type: string, page: number = 1, limit: number = 8) {
    return this.http.get<Paginate<Message[]>>(this.goPath + `messages/files?roomId=${roomId}&type=${type}&page=${page}&limit=${limit}`, { headers: this.headerOptions });
  }

  getNewMember(roomId: string, page: number = 1, limit: number = 20) {
    return this.http.get<Paginate<Employee[]>>(this.goPath + `members/addToRoom?roomId=${roomId}&page=${page}&limit=${limit}`, { headers: this.headerOptions });
  }

  getDetailGroup(roomId: string) {
    return this.http.get(this.goPath + `rooms/${roomId}`, { headers: this.headerOptions });
  }

  downloadImage(url: string) {
    return this.http.get(url, { responseType: 'blob' });
  }

  getUnreadMsg() {
    return this.http.get<ResponseData<any>>(this.goPath + `messages/unread`, { headers: this.headerOptionsJson });
  }


  async download(imageName: string, imageOriginalName: string, roomId: string) {
    try {
      const storageUrl = await this.storagePathProvider.getStorageChat({ roomId: roomId });
      await this.fileDownloaderProvider.downloadWithHttp(storageUrl.urlDownload, imageName, imageOriginalName);
    } catch (error) {
      this.nestResponseProvider.error(error);
    }
  }

  // ALL METHOD POST
  createRooms(type: string = "personal", criteria: any) {
    return this.http.post(this.goPath + 'rooms/' + type, criteria, { headers: this.headerOptions });
  }

  sendMessage(criteria: any) {
    return this.http.post(this.goPath + 'messages', criteria, { headers: this.headerOptions });
  }

  uploadImage(url: string, image: any, fileName: string) {
    const formData = new FormData();
    formData.append('fileName', fileName);
    formData.append('file', image, fileName);

    return this.http.post(url, formData, { headers: this.headerOptions });
  }

  addNewMember(roomId: string, criteria: any) {
    let headerOptions = new HttpHeaders().set('Authorization', this.accessToken).append('Content-Type', 'application/json');
    return this.http.post(this.goPath + `members/addToRoom?roomId=${roomId}`, JSON.stringify(criteria), { headers: headerOptions });
  }

  // ALL METHOD PUT
  updateRooms(roomId: string, criteria: any) {
    return this.http.put(this.goPath + `rooms/${roomId}`, criteria, { headers: this.headerOptionsJson });
  }

  changeRoleMember(roomId: string, criteria: any) {
    return this.http.put(this.goPath + `rooms/${roomId}/changeRole`, criteria, { headers: this.headerOptionsJson });
  }

  // ALL METHOD DELETE
  deleteMessage(messageId: string) {
    return this.http.delete(this.goPath + `messages/${messageId}`, { headers: this.headerOptions });
  }

  deleteRooms(roomId: string) {
    return this.http.delete(this.goPath + `rooms/${roomId}`, { headers: this.headerOptions });
  }

  membersLeaveGroup(roomId: string) {
    return this.http.delete(this.goPath + `members/leaveGroup/${roomId}`, { headers: this.headerOptions });
  }

  kickMemberGroup(roomId: string, empId: string) {
    return this.http.delete(this.goPath + `members/kickMember/${roomId}?employeeId=${empId}`, { headers: this.headerOptions });
  }

  // for file opener
  getMIMEtype(extn) {
    let ext = extn.toLowerCase();
    let MIMETypes = {
      'txt': 'text/plain',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'doc': 'application/msword',
      'pdf': 'application/pdf',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'bmp': 'image/bmp',
      'png': 'image/png',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'rtf': 'application/rtf',
      'ppt': 'application/vnd.ms-powerpoint',
      'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    }
    return MIMETypes[ext];
  }

}



// WEBPACK FOOTER //
// ./src/providers/chat-service/chat-service.ts